import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 4px;
  }

  ${({ $small }) =>
    $small &&
    css`
      align-items: center;
    `}

  h1 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;

    ${({ $small }) =>
      $small &&
      css`
        font-size: 68px;
        margin-top: -24px;
      `}
  }

  h3 {
    font-family: 'Bebas Neue', sans-serif;

    ${({ $small }) =>
      $small &&
      css`
        font-size: 40px;
      `}
  }
`;
